// 無限ループ版: Dawn の SliderComponent を継承
class LoopingSliderComponent extends SliderComponent {
  constructor() {
    super();//親クラス SliderComponent の constructor が全部走る
    if (!this.slider) return;

    // 初回ジャンプ済みフラグ
    this._didInitialJump = false; 

    // 無限ループON（親のupdateでprev/nextのdisabled制御をスキップ）
    this.enableSliderLooping = true;

    // 状態フラグ
    this._loopPrepared   = false; // クローン準備済みか
    this._isTeleporting  = false; // 瞬間移動(テレポート)中か

    // 1) クローン準備（先頭に末尾の複製／末尾に先頭の複製）
    this._cloneSlidesForLoop();

    // 2) ページ計算（clone除外で）　SliderComponent内のresetPages()実行。中でinitPages()も呼ばれてる
    this.resetPages();

    // 3) スクロールで境界検知（最初/最後を跨いだらテレポート）
    this._onScrollHandler = this._checkInfiniteScroll.bind(this);
    this.slider.addEventListener('scroll', this._onScrollHandler, { passive: true });

    // 4) 画像やフォント読み込み後に初期位置を微調整（初回のズレ防止）
    const rejump = () => {
      if (this._didInitialJump || !this._loopPrepared) return;
      const firstReal = this._getFirstRealSlide();
      if (firstReal) {
        this._instantJump(firstReal.offsetLeft);
        this._didInitialJump = true;
      }
    };
    window.addEventListener('load', rejump, { once: true });
    setTimeout(rejump, 400); // 予備（↑と両方来ても once とフラグで 1 回だけ）
  }

  /* ========== クローン作成（必要な時だけ） ========== */
  _cloneSlidesForLoop() {
    if (this._loopPrepared) return;

    // 横に溢れていなければ無限化不要
    const overflows = this.slider.scrollWidth > this.slider.clientWidth + 1; //小数点誤差で「溢れている」と誤判定しないように+1で確認
    if (!overflows) return;
    //クローンされてない要素だけ格納
    const realSlides = Array.from(this.querySelectorAll('[id^="Slide-"]'))
      .filter((el) => !el.classList.contains('is-clone'));
    if (realSlides.length < 2) return;

    const first = realSlides[0];
    const last  = realSlides[realSlides.length - 1];

    const firstClone = first.cloneNode(true);
    const lastClone  = last.cloneNode(true);

    firstClone.classList.add('is-clone');
    lastClone.classList.add('is-clone');

    // クローンは操作対象から外す（誤クリック/フォーカス防止）
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.tabIndex = -1;
    lastClone.tabIndex  = -1;

    // id衝突防止（id/aria-controls/for/href=#id を最小限ユニーク化）
    this._uniquifyIdsDeep(firstClone, '-clone');
    this._uniquifyIdsDeep(lastClone,  '-clone');

    // 先頭に「最後のクローン」、末尾に「最初のクローン」をおく
    this.slider.insertBefore(lastClone, this.slider.firstElementChild);
    this.slider.appendChild(firstClone);

    // DOM確定後に実スライド先頭へ瞬時ジャンプ（初期のブレ防止）つまりクローンを差し込んだあと、ブラウザが一度レイアウトを描画し終わってから、本物の1枚目の位置にピタッと合わせ直す」
    requestAnimationFrame(() => {
      const firstReal = this._getFirstRealSlide();
      if (firstReal) this._instantJump(firstReal.offsetLeft);
    });

    this._loopPrepared = true;
  }

  // 子孫を含め、id/aria-controls/for/href(#id) をユニーク化
  _uniquifyIdsDeep(root, suffix) {
    if (root.id) root.id = root.id + suffix;
    root.querySelectorAll('[id]').forEach((el) => { el.id = el.id + suffix; });
    root.querySelectorAll('[aria-controls]').forEach((el) => {
      el.setAttribute('aria-controls', el.getAttribute('aria-controls') + suffix);
    });
    root.querySelectorAll('label[for]').forEach((el) => {
      el.setAttribute('for', el.getAttribute('for') + suffix);
    });
    root.querySelectorAll('a[href^="#"]').forEach((el) => {
      el.setAttribute('href', el.getAttribute('href') + suffix);
    });
  }

  /* ========== ページ計算（clone除外で） ========== */
  initPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (el) => el.clientWidth > 0 && !el.classList.contains('is-clone')
    );

    if (this.sliderItemsToShow.length === 0) return;

    if (this.sliderItemsToShow.length === 1) {
      this.sliderItemOffset = this.sliderItemsToShow[0].clientWidth || 1;
      this.slidesPerPage = 1;
      this.totalPages    = 1;
      this.currentPage   = 1;
      this.update();
      return;
    }

    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );

    this.totalPages  = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.currentPage = 1; // 基準を必ず「本物スライドの先頭」に揃えるために、1に固定しています。
    this.update();
  }

  /* ========== スクロールの都度の更新（テレポート中は無視） ========== */
  update() {
    if (!this.slider || !this.nextButton) return;
    if (this._isTeleporting) return;

    const previousPage = this.currentPage;

    // 実スライド先頭のoffsetを基準にページ算出（cloneのズレ吸収）
    const base  = this.sliderItemsToShow?.[0]?.offsetLeft || 0;
    const denom = this.sliderItemOffset || 1;
    const raw   = Math.round((this.slider.scrollLeft - base) / denom) + 1;
    const max   = this.totalPages || this.sliderItemsToShow.length || 1;
    this.currentPage = Math.min(Math.max(1, raw), max);

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent   = this.totalPages;
    }

    const idx = this.currentPage - 1;
    const currentEl = this.sliderItemsToShow?.[idx];
    if (this.currentPage !== previousPage && currentEl) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: { currentPage: this.currentPage, currentElement: currentEl },
      }));
    }
    // 親のボタンdisabled制御は enableSliderLooping=true でスキップ
  }

  /* ========== 境界検知（最初/最後を跨いだらテレポート） ========== */
  _checkInfiniteScroll() {
    if (this._isTeleporting) return;

    const firstReal = this._getFirstRealSlide();
    const lastReal  = this._getLastRealSlide();
    if (!firstReal || !lastReal) return;

    const now = this.slider.scrollLeft;
    const tolBase = this.sliderItemOffset || 1;
    const tol = Math.max(6, Math.round(tolBase * 0.25)); // ← 少し広げる

    // 右端（最終実スライドの右端）付近→先頭へ
    const rightEdge = lastReal.offsetLeft + lastReal.clientWidth;
    if (now >= rightEdge - tol) {
      this._instantJump(firstReal.offsetLeft);
      return;
    }

    // 左端（実スライド先頭より左＝クローン領域）→最後へ
    const leftEdgeReal = firstReal.offsetLeft;
    if (now <= leftEdgeReal - tol) {
      this._instantJump(lastReal.offsetLeft);
    }
  }

  /* ========== テレポート（ちらつき最小化） ========== */
  _instantJump(left) {
    this._isTeleporting = true;        // update/検知を止める
    this._toggleSnap(false);           // 一瞬だけ snap を無効化

    const el = this.slider;
    const prevBehavior = el.style.scrollBehavior;
    

    
    // 2フレーム使って「描画→戻す」を保証
    requestAnimationFrame(() => {
      //1フレーム目：瞬間移動
      el.style.scrollBehavior = 'auto';
      el.scrollLeft = left;
      requestAnimationFrame(() => {
        //2フレーム目：元に戻す
        el.style.scrollBehavior = prevBehavior || '';
        this._toggleSnap(true);        // snap復帰
        
        // 少し待ってから状態同期
        setTimeout(() => {
          this._isTeleporting = false;
          this.update();               // 念のため明示更新
        }, 40);
      });
    });
  }

  // scroll-snap のON/OFF（no-snapクラスを付け外し）
  _toggleSnap(enable) {
    if (enable) {
      this.slider.classList.remove('no-snap');
    } else {
      this.slider.classList.add('no-snap');
    }
  }

  /* ========== 実スライド集合（clone除外） ========== */
  _getRealSlides() {
    return Array.from(this.querySelectorAll('[id^="Slide-"]'))
      .filter((el) => !el.classList.contains('is-clone') && el.clientWidth > 0);
  }
  _getFirstRealSlide() { return this._getRealSlides()[0] || null; }
  _getLastRealSlide()  { const a = this._getRealSlides(); return a[a.length - 1] || null; }

  /* ========== ボタンクリック：境界時は先にテレポート ========== */
  onButtonClick(event) {
    const isFirst = this.currentPage === 1;
    const isLast  = this.currentPage === this.sliderItemsToShow.length;

    if (isFirst && event.currentTarget.name === 'previous') {
      const lastReal = this._getLastRealSlide();
      if (lastReal) {
        event.preventDefault();
        this._instantJump(lastReal.offsetLeft);
        return;
      }
    }
    if (isLast && event.currentTarget.name === 'next') {
      const firstReal = this._getFirstRealSlide();
      if (firstReal) {
        event.preventDefault();
        this._instantJump(firstReal.offsetLeft);
        return;
      }
    }

    // それ以外は親のロジック（smoothのまま）
    super.onButtonClick(event);
  }
}

customElements.define('looping-slider', LoopingSliderComponent);
